import styled from '@emotion/styled';
import { Range, getTrackBackground } from 'react-range';

import { normalizeValue } from '../Histogram/utils';
import { Icon } from '../Icon';

import type { FC } from 'react';

const StyledRangeThumb = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.colors.gray[400]};
  background: ${({ theme }) => theme.palette.colors.white};
  box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.colors.gray[300]};
  transition: all 0.1s;

  :focus,
  :hover,
  :active {
    outline: none;
    box-shadow: 0 0 0 5px ${({ theme }) => theme.palette.colors.gray[300]};
  }
`;

const StyledRangeTrack = styled.div<RangeTrackProps>`
  height: 3px;
  width: 100%;
  align-self: center;
  background: ${({ value: values, max, theme }) =>
    getTrackBackground({
      values,
      colors: [
        'rgba(230, 230, 230, 0.38)',
        theme.palette.colors.gray[300],
        'rgba(230, 230, 230, 0.38)',
      ],
      min: 0,
      max: max,
    })};
`;

const StyledRangeTrackRoot = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing(6)};
`;

type RangeTrackProps = { value: number[]; max: number };
type RangeSlider = {
  value: number[];
  onChange: (value: number[]) => void;
  max: number;
  step?: number;
};

export const RangeSlider: FC<RangeSlider> = ({ value, onChange, max, step = 1 }) => {
  return (
    <Range
      values={value}
      step={step}
      min={0}
      max={max}
      onChange={onChange}
      renderTrack={({ props, children }) => (
        <StyledRangeTrackRoot onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
          <StyledRangeTrack
            ref={props.ref}
            value={value.map((el) => normalizeValue(el, max))}
            max={100}
          >
            {children}
          </StyledRangeTrack>
        </StyledRangeTrackRoot>
      )}
      renderThumb={({ props }) => (
        <StyledRangeThumb {...props}>
          <Icon type="slider-thumb" />
        </StyledRangeThumb>
      )}
    />
  );
};
